<template>
  <div class="pageBox">
    <div class="content">
      <div class="applicationBox">
        <el-form
          class="formBox"
          :model="form"
          ref="form"
          label-width="auto"
          label-position="top"
          disabled>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <div class="formTitle">通用设置</div>
              <div class="formContent">
                <el-form-item prop="linkName">
                  <span slot="label" class="label">链接名称</span>
                  <div class="msg">请填写链接名称，仅用于链接管理。</div>
                  <el-input
                    placeholder="请填写链接名称，15个字以内"
                    v-model.trim="form.linkName"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item >
                  <span slot="label" class="label">
                    设置应用的自定义兜底页
                    <a :href="'/documents/'+'5611405056246784'" target="_blank" > <i class="el-icon-question"></i></a>
                  </span>
                  <div class="msg">
                    若当前设备无法打开应用商店链接或唤起应用时，AppLink链接将跳转至
                    <span class="color4285F5 cursor" @click="openImg()">报错页面</span>
                    <br>
                    您也可以根据规则设置
                    <a :href="'/documents/'+'5630896251290624'" target="_blank" ><span class="color4285F5">自定义兜底页</span></a>
                  </div>
                  <el-input
                    placeholder="请填写兜底页URL地址，最多500个字符"
                    v-model.trim="form.apkUrl"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="formTitle">安卓/鸿蒙设置</div>
              <div class="formContent">
                <el-form-item >
                  <span slot="label" class="label">
                    设置安卓/鸿蒙的应用唤起路径
                    <a :href="'/documents/'+'5611405056246784'" target="_blank" > <i class="el-icon-question"></i></a>
                  </span>
                  <div class="msg">
                    设置后用户能通过统一链接打开应用内的指定页面。
                  </div>
                  <el-input
                    placeholder="请填写deeplink地址，最多500个字符"
                    v-model.trim="form.androidDeeplink"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item>
                  <span slot="label" class="label">
                    设置自定义归因参数
                    <a :href="'/documents/'+'5611405056246784'" target="_blank" > <i class="el-icon-question"></i></a>
                  </span>
                  <div class="msg">
                    可按照自主定义的逻辑编写归因参数（referrer），各厂商开放平台可直接调取归因的参数。
                  </div>
                  <div class="ascribeList">
                    <div class="ascribeItem">
                      <div class="label">流量来源 (source)</div>
                      <el-form-item 
                        class="formItem" 
                        prop="source">
                        <el-input
                          placeholder="仅支持英文、数字，最多100个字符"
                          v-model.trim="form.source">
                        </el-input>
                        <div class="msg">用于标识流量来源的参数，例如广告平台、搜索引擎、社交媒体等</div>
                      </el-form-item>
                    </div>
                    <div class="ascribeItem">
                      <div class="label">流量媒介 (medium)</div>
                      <el-form-item 
                        class="formItem" 
                        prop="medium">
                        <el-input
                          placeholder="仅支持英文、数字，最多100个字符"
                          v-model.trim="form.medium">
                        </el-input>
                        <div class="msg">用于标识流量媒介的参数，例如广告、邮件、社交媒体帖子等。</div>
                      </el-form-item>
                    </div>
                    <div class="ascribeItem">
                      <div class="label">营销活动 (campaign)</div>
                      <el-form-item 
                        class="formItem" 
                        prop="campaign">
                        <el-input
                          placeholder="仅支持英文、数字，最多100个字符"
                          v-model.trim="form.campaign">
                        </el-input>
                        <div class="msg">用于标识流量所属的广告活动或营销活动的参数。</div>
                      </el-form-item>
                    </div>
                    <div class="ascribeItem">
                      <div class="label">关键词 (term)</div>
                      <el-form-item 
                        class="formItem" 
                        prop="term">
                        <el-input
                          placeholder="仅支持英文、数字，最多100个字符"
                          v-model.trim="form.term" >
                        </el-input>
                        <div class="msg">用于标识用户搜索的关键词的参数。</div>
                      </el-form-item>
                    </div>
                    <div class="ascribeItem">
                      <div class="label">广告内容 (content)</div>
                      <el-form-item 
                        class="formItem" 
                        prop="content">
                        <el-input
                          placeholder="仅支持英文、数字，最多100个字符"
                          v-model.trim="form.content" >
                        </el-input>
                        <div class="msg">用于标识广告或链接的具体内容的参数，例如不同广告创意、按钮文本等。</div>
                      </el-form-item>
                    </div>
                  </div>
                </el-form-item> -->
              </div>
              <div class="formTitle">iOS设置</div>
              <div class="formContent">
                <el-form-item >
                  <span slot="label" class="label">
                    设置iOS的跳转路径
                    <a :href="'/documents/'+'5611405056246784'" target="_blank" > <i class="el-icon-question"></i></a>
                  </span>
                  <div class="msg">
                    设置iOS的跳转路径后，iOS设备重定向至您设置的iOS跳转路径，未设置iOS的跳转路径时，iOS设备重定向至报错页面;
                    iOS平台建议使用Universal Links链接，查看
                    <el-link class="color4285F5" href="https://developer.apple.com/ios/universal-links/" target="_blank" :underline="false">Universal Links说明</el-link>
                  </div>
                  <el-input
                    placeholder="请输入Universal Links链接地址，最多500个字符"
                    v-model.trim="form.iosUrl"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <el-button
          class="w200 closeBtn"
          @click="$router.back(-1)">
          关闭
        </el-button>
      </div>
    </div>
    <imgDialog ref="imgDialog"></imgDialog>
  </div>
</template>
<script>
import imgDialog from "./dialog/imgDialog.vue"; 
export default {
  components: {
    imgDialog
  },
  data() {
    var checkNoCh = (rule, value, callback) => {
      if(this.value){
        let reg = /[\u4E00-\u9FA5]/g;
          console.log(reg.test(value))
        if (reg.test(value)) {
          callback(new Error("应用包不可输入中文"));
        } else {
          callback();
        }
      }else{
        callback();
      }
    };
    return {
      error: "", //提交认证错误信息
      value:false, 
      form: {
        linkName: "", //应用名称
        apkUrl: "", //兜底页
        source: "", //流量来源
        medium: "", //流量媒介
        campaign: "", //营销活动
        term: "", //关键词
        content: "", //广告内容
        androidDeeplink:"",
        iosUrl: "", //iOS跳转路径
      },

    };
  },
  created() {
    this.queryModifyDetail();
  },
  methods: {
    openImg(){
      this.$refs['imgDialog'].show()
    },
    //链接详情
    queryModifyDetail() {
      this.$apis.consoleSever.queryModifyDetail({
        appLinkAuditId:this.$route.query.appLinkAuditId
      }).then((res) => {
        if (res.code == 0) {
          this.form = res.data;
 
        }
      });
    },

  },
};
</script>

<style scoped lang="scss">
.pageBox {
  padding: 20px;
  border-radius: 5px;
  min-height: calc(100% - 94px); //减底部(20px+ICP高度+20px)
  .content {
    background: #fff;
    box-shadow: $--background-shadow-base;
    .applicationBox {
      padding: 70px 50px;
      .formBox {
        width: 1000px;
        .formTitle{
          padding: 10px 0;
          margin-bottom: 10px ;
          border-bottom: 1px solid #DCDFE6;
          color: #606266;
          font-size: 20px;
          font-weight: bold;
        }
        .formContent{
          /deep/ .el-form-item__label{
            position: relative;
            line-height: 20px;
            font-size: 15px;
            font-weight: bold;
          }
          .msg {
            margin: 5px 0;
            line-height: 26px;
            color: #999;
            .color4285F5{
              color: #4285F5;
            }
          }
          .switch{
            margin: 0 10px;
            margin-top: -2px;
          }
          .ascribeList{
            .ascribeItem{
              display: flex;
              .formItem{
                flex: 1;
                margin-bottom: 10px;
                /deep/ .el-form-item__error{
                  position: relative;
                  margin-top: -5px;
                }
              }
              .label{
                width: 160px;
                color: #606266;
              }
              .msg{
                margin: 0;
              }
            }
          }
        }
      }
      .closeBtn{
        margin-left: 400px;
      }
    }
  }
}
</style>

